import { action, computed, observable, runInAction } from "mobx";
import toastService from "../services/ToastService";

// import moment from "moment";

class UpdateBirdContentStore {
  constructor(http) {
    this.http = http;
  }

  @observable isModalOpen = false;

  // RA Mapping Editor

  @observable RAs = [];
  @observable RAmappings = [];
  @observable filteredRAMappings = [];
  @observable RAMappingsSearch = "";
  @observable selectedMapping = {};

  @observable htmlValuesFromBackend = {};
  @observable selectedHtmlKV = undefined;

  // Notifications
  @observable
  subscriptions = [];

  @observable
  ADGroups = [];

  // LOV Editor

  @action
  init() {
    this.LOVs = undefined;
    this.fieldList = undefined;
    this.valueList = undefined;
    this.selectedType = undefined;
    this.selectedField = undefined;
    this.selectedValue = {
      tid: undefined,
      value: undefined,
      priority: undefined,
    };
    this.itemsWhereBeingUsed = [];
    this.error = undefined;
    this.isModalOpen = false;
  }

  // Notifications
  @computed
  get getSubscriptions() {
    return this.subscriptions;
  }

  @computed
  get getSelectedHtmlKV() {
    return this.selectedHtmlKV;
  }

  @action
  setSelectedHtmlKV = (a) => {
    this.selectedHtmlKV = a;
  };

  @action
  fetchHTMLDataFromBackend = () => {
    const kvParam = {
      type: "KV",
      filter: {
        type: "KV",
        kvType: { in: ["HTML"] },
      },
    };

    return this.http
      .fetchEntities(kvParam)
      .then((response) => {
        runInAction(() => {
          if (!response || !response.results || !response.results.length) {
            return;
          }
          this.bannerValues = response.results[0].details;
          this.selectedHtmlKV = response.results[0];

          this.htmlValuesFromBackend = response.results.reduce(function (
            map,
            obj
          ) {
            map[obj.key] = obj;
            return map;
          },
          {});
        });
      })
      .catch((error) => {
        toastService.func_notify(
          "Error while loading banner text.",
          "error",
          error
        );
      });
  };

  @action
  saveHtml = (bannerValue) => {
    const params = {
      actionType: "UpdateObject",
      object: {
        type: this.selectedHtmlKV.type,
        tid: this.selectedHtmlKV.tid,
        kvType: this.selectedHtmlKV.kvType,
        key: this.selectedHtmlKV.key,
        value: "Value is stored in detailed values.",
        description: this.selectedHtmlKV.description,
        details: bannerValue,
        kvComment: this.selectedHtmlKV.kvComment,
        effectiveFrom: this.selectedHtmlKV.effectiveFrom,
      },
    };
    this.http
      .func_sendGeneralMessage(params)
      .then((response) => {
        if (!response || !response.data) {
          return;
        }
        runInAction(async () => {
          toastService.func_notify(
            `Banner text saved successfully.`,
            "info"
          );
        });
      })
      .catch((error) => {
        toastService.func_notify(error, "error");
      });
  };

  @action
  func_handleTransferClick = async () => {
    let birdTransferParameters = {
      frameworkIds: this.selectedFrameworks,
      includeMapping: this.includeMappingContent,
      includeRendering: this.includeRenderingContent,
      finalReleaseTids: this.selectedFinalReleases,
      otherBranchTids: this.selectedOtherBranches,
      versionTitle: this.versionTitle,
      versionDescription: this.versionDescription,
      dryRun: this.dryRun,
    };

    if (this.controllerForMultiSearchQuery && this.transferringData) {
      this.controllerForMultiSearchQuery.abort();
    }

    const controller = new window.AbortController();
    const signal = controller.signal;
    this.controllerForMultiSearchQuery = controller;

    this.transferringData = true;
    this.http
      .transferBirdContent(birdTransferParameters, signal)
      .then((response) => {
        runInAction(async () => {
          const isSuccess = response?.result === "SUCCESS"
          toastService.func_notify(
            isSuccess ? `Bird Content successfully sent` : response.resultMessage ?? "Sending Bird Content failed.",
            isSuccess ? "info" : "error"
          );
        });
      })
      .catch((error) => {
        toastService.func_notify(error, "error");
      });
  };

  @computed
  get getHtmlValuesFromBackend() {
    return this.htmlValuesFromBackend;
  }

  @action
  setHtmlValuesFromBackend(htmlValuesFromBackend) {
    return (this.htmlValuesFromBackend = htmlValuesFromBackend);
  }

  @action
  fetchSubscriptions() {
    const params = {
      types: ["KV"],
      filter: {
        kvType: { in: ["subscription"] },
        type: "KV",
        activeTo: {
          isNull: true,
        },
      },
    };
    return this.http
      .query(params)
      .then((subscriptionData) => {
        runInAction(() => {
          if (
            !subscriptionData ||
            !subscriptionData.data ||
            !subscriptionData.data.results
          ) {
            return;
          }
          this.subscriptions = subscriptionData.data.results;
        });
      })
      .catch((error) => {
        toastService.func_notify(error, "Error");
      });
  }
}

export default UpdateBirdContentStore;
